import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IRequestSmsPhoneNumberResponse } from 'src/api/landlord-messages-api';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { type TCountry } from 'src/components/input/select-area-code/area-codes';

const PATH = 'api/landlord/messages/associate-phone-number';

type ApiResponse = IRequestSmsPhoneNumberResponse;
type Response = ApiResponse['phone_number'];

type ClientSidePayload = { areaCode?: string, countryCode?: TCountry };
type ApiRequestPayload = { area_code?: string, country_code?: TCountry };

export const useAssociatePhoneNumber = () => {
    const queryClient = useQueryClient();

    return useMutation<Response, IStandardErrorResponse, ClientSidePayload>(
        async (payload) => {
            // never send the empty string in the area code field
            const json: ApiRequestPayload = { area_code: payload.areaCode || undefined, country_code: payload.countryCode };
            const response = await apiClient(PATH, { method: 'post', json }).json<ApiResponse>();
            return response.phone_number;
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries([queryKeys.loggedInUser]);
            }
        }
    );
};
